var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11458_110028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52447 5.08937C9.67415 4.62872 10.3259 4.62871 10.4755 5.08937L11.0961 6.9992C11.2969 7.61724 11.8728 8.03568 12.5227 8.03568H14.5308C15.0151 8.03568 15.2165 8.65548 14.8247 8.94019L13.2001 10.1205C12.6743 10.5025 12.4543 11.1795 12.6552 11.7976L13.2757 13.7074C13.4254 14.1681 12.8981 14.5511 12.5063 14.2664L10.8817 13.0861C10.3559 12.7041 9.64405 12.7041 9.11832 13.0861L7.49372 14.2664C7.10187 14.5511 6.57463 14.1681 6.7243 13.7074L7.34484 11.7976C7.54566 11.1795 7.32567 10.5025 6.79994 10.1205L5.17534 8.94018C4.78348 8.65548 4.98487 8.03568 5.46923 8.03568H7.47735C8.12719 8.03568 8.70312 7.61724 8.90393 6.9992L9.52447 5.08937Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75781,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11458_110028"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.00781,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/starGray.74f78e20fac6391e964d8a1534eda878.svg";
export { ForwardRef as ReactComponent };